import { render, staticRenderFns } from "./NFTGridComponent.vue?vue&type=template&id=33995eca&scoped=true&"
import script from "./NFTGridComponent.vue?vue&type=script&lang=ts&"
export * from "./NFTGridComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NFTGridComponent.vue?vue&type=style&index=0&id=33995eca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33995eca",
  null
  
)

export default component.exports